import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=4b122356&scoped=true&"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js&"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=4b122356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b122356",
  null
  
)

export default component.exports